<template>
  <div class="PageNotFound">
    <Transition>
    <div class="container text-center">
        <div class="page404 m-5">
            <h2>{{title}}</h2>
            <p>{{description}}</p>
        </div>
    </div>
    </Transition>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'PageNotFound',
  data () {
    return {
      title: '...',
      description: 'کمی صبر کنید.'
    }
  },
  beforeMount () {
    this.setMetaByObj({
      seoTitle: 'صفحه مورد نظر یافت نشد.',
      seoKeyword: '',
      seoDescription: ''
    })
    this.fetchRedirectRules()
  },
  methods: {
    async fetchRedirectRules () {
      const query = `
{
  redirects {
    oldPath
    newPath
  }
}
      `
      const response = await this.$fetchGraphQL(query)
      const currentPath = this.$route.path
      const redirectRule = response.data.redirects.find(rule => rule.oldPath === currentPath.replace(/\/$/, ''))

      if (redirectRule) {
        this.$router.replace(redirectRule.newPath)
      } else {
        this.title = '۴۰۴ خطای'
        this.description = 'صفحه مورد نظر یافت نشد!'
      }
    }
  }
}
</script>
<style scoped>
.PageNotFound{
    height: 78vh;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row-reverse;
    flex-wrap: wrap;
}
.page404{
    width: -webkit-fill-available;
    color:#5e5b57;
}
</style>
